export default __webpack_public_path__ + "static/media/newFilterIcon.b07c2b9b.svg";